import { Car } from '@lib/azgaz-ui/connect';
import formatBrand from '@/utils/formatBrand';
import getCarPrice from '@/utils/getCarPrice';
import { cityIn } from 'lvovich';

const getSeoTags = (car: Car) => {
  let title: string = '';
  let description: string = '';

  const brandName = formatBrand(car.brand);

  const getSpecification = () => {
    const carSpec = car.specification[0].items;
    const findSpec = (field: string) => {
      const spec = carSpec.find((item: any) => item.id === field);
      return spec?.value;
    };
    const drive = findSpec('drive');
    const transmission = findSpec('transmission');
    const engine = findSpec('engine');

    return {
      grade: `${drive}, ${transmission}, ${engine}`,
      drive,
      transmission,
      engine
    };
  };

  const {grade, transmission, drive, engine} = getSpecification();

  const { price } = getCarPrice(car);

  // Старое
  // title = `${brandName} ${car.model} ${car.year}, ${grade} в наличии ${car.main_office.city}`;
  // description = `${brandName} ${car.model} ${car.year} ${grade} VIN: ${car.vin} купить по цене ${price} у официального дилера ${brandName}. ${car.main_office.phone}`;

  title = `Купить ${brandName} ${car.model} ${car.color.name} в ${cityIn(car.main_office.city)} | ${car.main_office.name}`
  description = `Купить новый автомобиль ${brandName} ${car.model} ${car.color.name} ${car.year} года выпуска, с двигателем — ${engine}, комплектации ${car.grade}, трансмиссии ${transmission} и приводом ${drive} у официального дилера Suzuki ${car.main_office.name} в ${car.main_office.city}.`;

  return { title, description };
};

export default getSeoTags;
